import {
  MailboxCreateInterface,
  MailboxInterface,
  MailboxRepositoryInterface,
  MailboxUserUpdateInterface, MailboxUserCreateInterface, MailboxUserInterface, MailboxStatus,
} from '@/services/Mailbox/interfaces';
import { AxiosInstance } from 'axios';

export default class MailboxRepository implements MailboxRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async createMailbox(data: MailboxCreateInterface): Promise<MailboxInterface> {
    const response = await this.axios.post('/mailbox/mailboxes', data);

    return response.data;
  }

  public async createMailboxUser(data: MailboxUserCreateInterface): Promise<MailboxUserInterface> {
    const response = await this.axios.post(`/mailbox/mailboxes/${data.mailboxId}/users`, data);

    return response.data;
  }

  public async updateMailboxUser(id: number, data: MailboxUserUpdateInterface): Promise<void> {
    await this.axios.patch(`/mailbox/users/${id}`, data);
  }

  public async getUserDecryptedPassword(id: number): Promise<string> {
    const response = await this.axios.get(`/mailbox/users/${id}/hash`, {responseType: 'text'});

    return response.data; // string
  }

  public async deleteMailbox(id: number): Promise<void> {
    await this.axios.delete(`/mailbox/mailboxes/${id}`);
  }

  public async deleteMailboxUser(id: number): Promise<void> {
    await this.axios.delete(`/mailbox/users/${id}`);
  }

  public async searchMailbox(page: number, search?: string, websiteId?: string): Promise<[MailboxInterface[], number]> {
    page = page < 1 ? 1 : page;

    let url = `/mailbox/mailboxes?page=${page}`;
    if (search) {
      url = `${url}&search=${search}`;
    }
    if (websiteId) {
      url = `${url}&websiteId=${websiteId}`;
    }

    const response = await this.axios.get(url);

    return response.data;
  }

  public async getOneById(id: number): Promise<MailboxInterface> {
    const response = await this.axios.get(`/mailbox/mailboxes/${id}`);

    return response.data;
  }

  public async toggleMailbox(id: number, status: MailboxStatus): Promise<void> {
    await this.axios.patch(`/mailbox/mailboxes/${id}/toggle`, { status });
  }

  public async syncQuotas(serverId: string): Promise<void> {
    await this.axios.patch(`/mailbox/mailboxes/servers/${serverId}/quotas/update`);
  }
}
